var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CounterpartyCard',{attrs:{"label":"Информация о контрагенте"}},[_c('VRow',_vm._l((_vm.info),function({label, value},index){return _c('VCol',{key:index,attrs:{"cols":"12","md":"3"}},[_c('StaticField',{attrs:{"label":label,"value":value}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }